import React from 'react';
import { Card, CardContent } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { Avatar } from './ui/Avatar';
import { Calendar, DollarSign, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export interface Project {
  id: string;
  name: string;
  brand: {
    name: string;
    logo?: string;
  };
  creator: {
    name: string;
    avatar: string;
  };
  deadline: string;
  status: 'planning' | 'active' | 'completed' | 'cancelled';
  budget: number;
}
interface ProjectCardProps {
  project: Project;
}
export function ProjectCard({
  project
}: ProjectCardProps) {
  const navigate = useNavigate();
  const statusVariant = project.status === 'active' ? 'success' : project.status === 'planning' ? 'default' : project.status === 'cancelled' ? 'destructive' : 'secondary';
  const daysLeft = Math.ceil((new Date(project.deadline).getTime() - new Date().getTime()) / (1000 * 3600 * 24));
  const isUrgent = daysLeft > 0 && daysLeft < 7;
  return <Card className="hover:shadow-md transition-shadow cursor-pointer" onClick={() => navigate(`/manager/projects/${project.id}`)} data-id="element-290">
      <CardContent className="p-6" data-id="element-291">
        <div className="flex justify-between items-start mb-4" data-id="element-292">
          <div data-id="element-293">
            <h3 className="font-bold text-gray-900" data-id="element-294">{project.name}</h3>
            <p className="text-sm text-gray-500" data-id="element-295">{project.brand.name}</p>
          </div>
          <Badge variant={statusVariant} className="capitalize" data-id="element-296">
            {project.status}
          </Badge>
        </div>

        <div className="flex items-center gap-3 mb-4" data-id="element-297">
          <Avatar src={project.creator.avatar} alt={project.creator.name} size="sm" data-id="element-298" />
          <span className="text-sm font-medium text-gray-700" data-id="element-299">
            {project.creator.name}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-300">
          <div className="flex flex-col" data-id="element-301">
            <span className="text-xs text-gray-500 mb-1 flex items-center" data-id="element-302">
              <Calendar className="h-3 w-3 mr-1" data-id="element-303" /> Deadline
            </span>
            <span className={`text-sm font-medium ${isUrgent ? 'text-red-600' : 'text-gray-900'}`} data-id="element-304">
              {project.deadline}
              {isUrgent && <span className="ml-1 text-xs font-normal text-red-500" data-id="element-305">
                  ({daysLeft} days left)
                </span>}
            </span>
          </div>
          <div className="flex flex-col" data-id="element-306">
            <span className="text-xs text-gray-500 mb-1 flex items-center" data-id="element-307">
              <DollarSign className="h-3 w-3 mr-1" data-id="element-308" /> Budget
            </span>
            <span className="text-sm font-medium text-gray-900" data-id="element-309">
              €{project.budget.toLocaleString()}
            </span>
          </div>
        </div>

        <div className="flex justify-between items-center pt-4 border-t" data-id="element-310">
          <Button variant="ghost" size="sm" onClick={e => e.stopPropagation()} data-id="element-311">
            Edit
          </Button>
          <Button variant="secondary" size="sm" className="group" data-id="element-312">
            View Details{' '}
            <ArrowRight className="h-3 w-3 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-313" />
          </Button>
        </div>
      </CardContent>
    </Card>;
}